<template>
<div class="con-sa" id="style-3">
    <div class="container-calendar-main" v-if="tavolo">
        <div class="cont-info">
            <div class="pren side-column">
                <div class="cont-cal">
                    <v-date-picker v-model="date" mode="dateTime"  />
                </div>
                <div class="preno">




                <div class="cont-btn-pre">
                    <div>
                        <span>Tavolo {{tavolo}}</span><br/>
                        <span>Sala {{sala}} </span>
                    </div>
                

                </div>
                <div class="cont-btn-pre" style="display: flex; gap: 10px; margin-top: 10px;">
                    <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="showBookingModal = true">Prenota Tavolo</a>
                    <a href="#" class="btn btn-outline-primary btn-sm" @click="() => aggiungiPiatti(tavolo)">Aggiungi Piatti</a>
                </div>
                </div>
            </div>
            <div class="pren middle-column">
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <span class="nav-link active" :style="{'backgroundColor':tab.prenotazioni? bgActive:bgInactive}" id="prenotazioni" @click="showTab">Prenotazioni  Sala {{prenotazionisala.length}}</span>
                    <!--<div class="pano-pren" v-show="tab.prenotazioni">
                            <div class="card" style="width: 18rem;">
                                <div >
                                    <ul class="list-group list-group-flush" v-for="prenotazioni in prenotazionisala" :key="prenotazioni._id">
                                        <li class="list-group-item m tavolo-pre">Tavolo: {{prenotazioni.numero}}</li>
                                        <li class="list-group-item m">Nome: {{prenotazioni.nome}}</li>
                                        <li class="list-group-item m">Cognome: {{prenotazioni.cognome}}</li>
                                        <li class="list-group-item m">Telefono :{{prenotazioni.telefono}}</li>
                                        <li class="list-group-item m">Coperti :{{prenotazioni.coperti}}</li>
                                        <li class="list-group-item m">Orario {{moment.unix(prenotazioni.tm).format('h:mm A')}}</li>
                                        <hr>
                                    </ul>
                                </div>
                            </div>
                        </div>-->
                </li>
                <li class="nav-item" >
                    <span class="nav-link active" :style="{'backgroundColor':tab.prenT? bgActive:bgInactive}" id="pren-t" @click="showTab">{{ $t('prenotazioni') }}  {{ $t('tavolo') }}</span>
                   <!-- <div class="pano-pren" v-show="tab.prenT">
                            <div class="card" style="width: 18rem;">
                                <div >
                                    <ul class="list-group list-group-flush" v-for="prenotazioni in prenotazionisala" :key="prenotazioni._id">
                                        <div v-if="prenotazioni.numero == tavolo">
                                        <li class="list-group-item m tavolo-pre">Tavolo: {{prenotazioni.numero}}</li>
                                        <li class="list-group-item m" >Nome: {{prenotazioni.nome}}</li>
                                        <li class="list-group-item m" >Cognome: {{prenotazioni.cognome}}</li>
                                        <li class="list-group-item m" >Telefono :{{prenotazioni.telefono}}</li>
                                        <li class="list-group-item m" >Coperti :{{prenotazioni.coperti}}</li>
                                        <li class="list-group-item m" >Orario {{moment.unix(prenotazioni.tm).format('h:mm A')}}</li>
                                        <hr>
                                        </div>
                                    </ul>
                                </div>
                            </div>
                        </div>-->
                </li>
                <li class="nav-item">
                   <span class="nav-link active" :style="{'backgroundColor':tab.ordinazioni? bgActive:bgInactive}" id ="ordini" @click="showTab">{{ $t('ordinazione') }}</span>
                        <!--<div class="pano-pren" v-show="tab.ordinazioni">
                            <div class="card" style="width: 18rem;">
                                <div v-if="ordinazione.length">
                                    <ul class="list-group list-group-flush" v-for="ordine in ordinazione" :key="ordine.t">
                                        <li class="list-group-item m">Tavolo: {{ordine.t}}, Giorno: {{ordine.tm}}</li>
                                        <li  class="m" v-for="p in ordine.ord" :key="p.piatto" >{{p.quantita}}:{{p.piatto}} {{p.aggiunta.length? ` + ${p.aggiunta.join('')}`:''}}, €:{{p.costoAggiunta?p.costoAggiunta + p.prezzo:p.prezzo}}</li>
                                        <a href="#" class="btn btn-outline-success btn-sm" @click="() => chiudiTavolo(ordine.idT,ordine.idO)">Chiudi Tavolo</a>
                                    </ul>
                                </div>
                            </div>
                        </div>-->
                </li>
            </ul>
                <div class="pano-pren" v-show="tab.ordinazioni">
                    <div class="card" >
                        <div v-if="ordinazione.length">
                            <ul class="list-group list-group-flush" v-for="ordine in ordinazione" :key="ordine.t">
                                <li class="list-group-item m">{{ $t('tavolo') }}: {{ordine.t}}, {{ $t('giorno') }}: {{ordine.tm}}</li>
                                <template v-for="(p, index) in ordine.ord" :key="index">
                                    <li v-if="index > 0 && p.ordine !== ordine.ord[index-1].ordine" class="list-group-item p-0" style="border:none;">
                                        <hr style="margin: 5px 0; border-top: 2px solid #ccc;">
                                    </li>
                                    <li class="m">
                                        {{p.quantita}}:{{p.piatto}} 
                                        {{p.aggiunta && p.aggiunta.length ? ` + ${formatAggiunte(p.aggiunta)}` : ''}}
                                        {{p.senza && p.senza.length? ` - ${p.senza.join(', ')}`:''}}
                                        <div v-if="p.nota" style="font-style: italic; font-size: 0.85em; color: #7f8c8d;">{{ $t('nota', 'Nota') }}: {{p.nota}}</div>
                                        , €:{{((p.costoAggiunta ? p.costoAggiunta + p.prezzo : p.prezzo) * (p.quantita || 1)).toFixed(2)}}
                                    </li>
                                </template>
                                 <li>{{ $t('totale') }}: {{totale}}</li>
                                <div style="display: flex; flex-wrap: wrap; gap: 10px; margin-top: 10px;">
                                    <a href="#" class="btn btn-outline-primary btn-sm" @click.prevent="() => aggiungiPiatti(ordine.t)">{{ $t('aggiungi_piatti', 'Aggiungi Piatti') }}</a>
                                    
                                    <!-- Se c'è una portata in marcia, mostra il tasto Servito -->
                                    <a v-if="getActiveAdv(ordine)" 
                                       href="#" 
                                       class="btn btn-outline-info btn-sm" 
                                       @click.prevent="() => segnaComeServito(ordine, getActiveAdv(ordine).portata)"
                                    >
                                       {{getActiveAdv(ordine).portata}}° Servito
                                    </a>

                                    <!-- Altrimenti, se c'è una portata successiva da mandare in marcia, mostra il tasto -->
                                    <a v-else-if="getNextPortata(ordine)" 
                                       href="#" 
                                       class="btn btn-outline-warning btn-sm" 
                                       @click.prevent="() => apriAvanzamentoModal(ordine)"
                                    >
                                       Manda in Marcia {{getNextPortata(ordine)}}°
                                    </a>

                                    <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="() => chiudiTavolo(ordine.idT,ordine.idO)">{{ $t('chiudi_tavolo') }}</a>
                                    <a href="#" class="btn btn-outline-info btn-sm" @click.prevent="() => generaPagamentoStripe(ordine.idT, ordine.idO)">Genera Pagamento</a>
                                </div>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="pano-pren" v-show="tab.prenT">
                        <div class="card" >
                            <div >
                                <ul class="list-group list-group-flush" v-for="prenotazioni in prenotazionisala" :key="prenotazioni._id">
                                    <div v-if="prenotazioni.numero == tavolo || prenotazioni.numero == 't' + tavolo">
                                    <li class="list-group-item m tavolo-pre">{{ $t('tavolo') }}: {{prenotazioni.numero}}</li>
                                    <li class="list-group-item m" >{{ $t('nome') }}: {{prenotazioni.nome}}</li>
                                    <li class="list-group-item m" >{{ $t('cognome') }}: {{prenotazioni.cognome}}</li>
                                    <li class="list-group-item m" >{{ $t('telefono') }} :{{prenotazioni.telefono}}</li>
                                    <li class="list-group-item m" >{{ $t('coperti') }} :{{prenotazioni.coperti}}</li>
                                    <li class="list-group-item m" >Orario {{moment.unix(prenotazioni.tm).format('h:mm A')}}</li>
                                    <hr>
                                    </div>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="pano-pren" v-show="tab.prenotazioni">
                            <div class="card" >
                                <div >
                                    <ul class="list-group list-group-flush" v-for="prenotazioni in prenotazionisala" :key="prenotazioni._id">
                                        <li class="list-group-item m tavolo-pre">{{ $t('tavolo') }}: {{prenotazioni.numero}}</li>
                                        <li class="list-group-item m">{{ $t('nome') }}: {{prenotazioni.nome}}</li>
                                        <li class="list-group-item m">{{ $t('cognome') }}: {{prenotazioni.cognome}}</li>
                                        <li class="list-group-item m">{{ $t('telefono') }} :{{prenotazioni.telefono}}</li>
                                        <li class="list-group-item m">{{ $t('coperti') }} :{{prenotazioni.coperti}}</li>
                                        <li class="list-group-item m" >Orario {{moment.unix(prenotazioni.tm).format('h:mm A')}}</li>
                                        <hr>
                                    </ul>
                                </div>
                            </div>
                        </div>   
            </div>
            <div class="pren notifications-column side-column">
                <!-- Sezione Ritardi Marcia -->
                <div class="notif-section mb-4" v-if="ritardiMarcia.length">
                    <h5 class="notif-title text-danger mb-3">⚠️ {{ $t('ritardi_marcia', 'Ritardi Marcia') }}</h5>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item d-flex justify-content-between align-items-center bg-transparent border-bottom px-0" v-for="m in ritardiMarcia" :key="m.idAdv">
                            <span class="small font-weight-bold">{{ $t('tavolo') }} {{ m.tavolo }} ({{ m.sala }})</span>
                            <span class="badge badge-danger badge-pill">{{ Math.floor(m.ritardoSecs / 60) }} min</span>
                        </li>
                    </ul>
                </div>

                <!-- Sezione Nuovi Ordini Asporto -->
                <div class="notif-section mb-4" v-if="asportoNotifications.length">
                    <h5 class="notif-title text-primary mb-3">📦 {{ $t('nuovi_asporto', 'Nuovi Asporto') }}</h5>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item d-flex justify-content-between align-items-center bg-transparent border-bottom px-0" v-for="o in asportoNotifications" :key="o._id">
                            <span class="small font-weight-bold">{{ o.nome }}</span>
                            <div class="text-right">
                                <div class="badge badge-primary badge-pill d-block">{{ o.oraRitiro }}</div>
                            </div>
                        </li>
                    </ul>
                </div>

                <!-- Sezione Chiamate Camerieri -->
                <div class="notif-section mb-4" v-if="chiamateCameriere.length">
                    <h5 class="notif-title text-warning mb-3">🔔 {{ $t('chiamate', 'Chiamate') }}</h5>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item d-flex justify-content-between align-items-center bg-transparent border-bottom px-0" v-for="(c, idx) in chiamateCameriere" :key="idx">
                            <span class="small font-weight-bold">{{ $t('tavolo') }} {{ c.tavolo }} ({{ c.sala }})</span>
                            <button class="btn btn-xs btn-outline-warning py-0 px-2" @click="() => apriEvadiChiamata(c)">Evadi</button>
                        </li>
                    </ul>
                </div>

                <!-- Placeholder se vuoto -->
                <div v-if="!ritardiMarcia.length && !asportoNotifications.length && !chiamateCameriere.length" class="text-center py-5">
                    <i class="fas fa-bell-slash text-muted d-block mb-2" style="font-size: 2rem;"></i>
                    <p class="text-muted small italic">{{ $t('nessuna_notifica', 'Nessuna notifica') }}</p>
                </div>
            </div>
        </div>
    </div>
    <div class="nav-sale">
        <div>{{sala}}</div>
        <div class="con-sal">
            <ul class="nav nav-tabs" v-for="(sal, index) in sale" :key="sal">
                <li class="nav-item">
                    <span class="nav-link active" :id="sal.nome" @click="() => cambiaSala(sal,numeroSale[index])">{{sal}}</span>
                </li>
            </ul>
            <a href="#" class="btn btn-outline-success btn-sm home" @click="home">{{ $t('home') }}</a>
            <button 
                class="btn btn-sm lista-prenotati-btn" 
                :class="unassociatedCount > 0 ? 'btn-danger' : 'btn-success'"
                @click="openPrenotatiModal"
            >
                {{ $t('lista_prenotati') }}
            </button>
            <button 
                class="btn btn-sm btn-primary asporto-btn ml-2" 
                @click="goToAsportoStaff"
            >
                {{ $t('client_asporto') }}
            </button>
            <button 
                class="btn btn-sm btn-outline-info ml-2" 
                @click="tavolo = ''"
            >
                Focus Sala
            </button>
        </div>
    </div>

    <!-- Switch Modalità: Preparazione / Servizio -->
    <div class="d-flex align-items-center justify-content-center my-3 gap-2">
        <span class="fw-bold text-dark" style="font-size: 0.95rem; text-transform: uppercase; letter-spacing: 0.5px;">Modalità:</span>
        <div class="btn-group" role="group" aria-label="Modalità Sala">
            <button 
                type="button" 
                class="btn btn-sm" 
                :class="modalita === 'preparazione' ? 'btn-warning active fw-bold text-dark' : 'btn-outline-warning'"
                @click="modalita = 'preparazione'"
            >
                <i class="fas fa-tools me-1"></i> Preparazione
            </button>
            <button 
                type="button" 
                class="btn btn-sm" 
                :class="modalita === 'servizio' ? 'btn-primary active fw-bold text-white' : 'btn-outline-primary'"
                @click="modalita = 'servizio'"
            >
                <i class="fas fa-concierge-bell me-1"></i> Servizio
            </button>
        </div>
    </div>

    <div class="visualizza-sala">
        <div class="tavolo" v-for="tavolo in tavoli" :key="tavolo"  ><img src="../assets/dinner-table.png" :id ="tavolo" @click="selezionaTavolo"><span class="num-t"><b>T{{tavolo}}</b></span></div>
    </div>

    <!-- Modal Conto -->
    <div class="coperti-modal-overlay" v-if="showModal">
        <div class="cont_conto" style="background-color: #2c3e50; border-radius: 12px; padding: 20px; color: white; width: 600px; max-width: 90vw;">
            <div style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #555; padding-bottom: 10px; margin-bottom: 20px;">
                <h3 class="modal__title" id="modal-title" style="margin: 0; background: none;">Bagni Fiore</h3>
                <span class="chiudi_modal" @click.prevent="showModal = false" style="background: #e74c3c; padding: 5px 15px; border-radius: 6px; cursor: pointer;">{{ $t('exit') || 'X' }}</span>
            </div>
            <div style="margin-bottom: 15px; display: flex; gap: 20px; align-items: center; flex-wrap: wrap;">
                <span class="cameriere" style="font-weight: bold;">Cameriere: {{ $t('waiter_name') }}</span>
                <span class="applica_sconto">
                    Sconto (€): <input type="number" v-model.number="sconto" style="width: 80px; border-radius: 4px; padding: 4px 8px; border: 1px solid #ccc; color: black;" />
                </span>
                <span class="dividi_conto">
                    Dividi per: <input type="number" min="1" v-model.number="numeroDivisione" style="width: 60px; border-radius: 4px; padding: 4px 8px; border: 1px solid #ccc; color: black;" />
                </span>
            </div>
            
            <div style="margin-bottom: 15px; background: rgba(255,255,255,0.1); padding: 10px; border-radius: 8px;">
                <div style="display: flex; gap: 20px; align-items: center; margin-bottom: 10px;">
                    <label style="font-weight: bold; margin: 0;">Metodo Pagamento:</label>
                    <div style="display: flex; align-items: center; gap: 5px;">
                        <input type="radio" v-model="metodoPagamento" value="contante" id="pagContanteCli">
                        <label for="pagContanteCli" style="margin: 0;">Contanti</label>
                    </div>
                    <div style="display: flex; align-items: center; gap: 5px;">
                        <input type="radio" v-model="metodoPagamento" value="digitale" id="pagDigitaleCli">
                        <label for="pagDigitaleCli" style="margin: 0;">Digitale</label>
                    </div>
                </div>
                <div style="display: flex; align-items: center; gap: 10px;">
                    <label style="font-weight: bold; margin: 0;">Email:</label>
                    <input type="email" class="form-control form-control-sm" v-model="emailScontrino" placeholder="cliente@email.com" style="flex: 1; color: black; background: white;" />
                </div>
            </div>
            <div class="lista_conto" v-for="(ordineItem, idx) in ordinazione" :key="idx" style="overflow-y: auto; max-height: 50vh;">
                <div class="list-group-item m" style="color: black; font-weight: bold; margin-bottom: 10px; border-radius: 8px;">Tavolo: {{ordineItem.t}} | Giorno: {{ordineItem.tm}} | Coperti: {{ordineItem.coperti}}</div>
                <div class="m item_cont" v-for="(p, pidx) in ordineItem.ord" :key="pidx" style="border-bottom: 1px dashed #555; padding: 8px 0; display: flex; flex-direction: column;">
                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;">
                        <span class="list_piatto" style="flex: 2; display: flex; align-items: center; gap: 8px;">
                            {{p.quantita}}x {{p.piatto}}
                            <button v-if="p._id" class="btn btn-sm btn-danger" @click.prevent="rimuoviPiattoDalTavolo(ordineItem.idO, p._id)" style="padding: 2px 6px; font-size: 0.8rem; border-radius: 4px;">Elimina</button>
                        </span> 
                        <span class="list_aggiunta" style="flex: 2; color: #f39c12;">{{p.aggiunta && p.aggiunta.length ? `+ ${formatAggiunte(p.aggiunta)}` : ''}}</span> 
                        <span class="list_prezzo" style="flex: 1; text-align: right;">€ {{((p.costoAggiunta ? p.costoAggiunta + p.prezzo : p.prezzo) * (p.quantita || 1)).toFixed(2)}}</span>
                    </div>
                    <div v-if="p.senza && p.senza.length" style="color: #e74c3c; font-size: 0.9em; padding-left: 20px;">- {{p.senza.join(', ')}}</div>
                    <div v-if="p.nota" style="font-style: italic; font-size: 0.9em; color: #7f8c8d; padding-left: 20px;">Nota: {{p.nota}}</div>
                </div>
            </div>
            <div style="margin-top: 20px; padding-top: 15px; border-top: 2px solid #555; text-align: right; font-size: 1.2rem;">
                <span :class="[sconto ? 'sconto' : '']" style="margin-right: 15px;">{{ $t('totale') }}: € {{totale.toFixed(2)}}</span>
                <span v-if="sconto" style="color: #2ecc71; font-weight: bold; margin-right: 15px;">Scontato: € {{(totale - sconto).toFixed(2)}}</span>
                <div v-if="numeroDivisione > 1" style="margin-top: 10px; font-weight: bold; color: #3498db;">
                    Totale per persona ({{numeroDivisione}}): € {{((totale - (sconto || 0)) / numeroDivisione).toFixed(2)}}
                </div>
            </div>
            <div class="conto_btn" style="margin-top: 25px; display: flex; gap: 10px; justify-content: center; flex-wrap: wrap;">
                <button class="btn btn-primary" @click.prevent="printPaper(selectedOrderIdT, selectedOrderIdO, 'ricevuta', [...ordinazione])">{{ $t('receipt') || 'Ricevuta' }}</button>
                <button class="btn btn-warning" @click.prevent="printPaper(selectedOrderIdT, selectedOrderIdO, 'preconto', [...ordinazione])">{{ $t('pre_receipt') || 'Preconto' }}</button>
                <button class="btn btn-success" @click.prevent="showFatturaModal = true">{{ $t('invoice') || 'Fattura' }}</button>
                <button class="btn btn-info" @click.prevent="inviaScontrinoElettronico()">Scontrino Elettr.</button>
                <button class="btn btn-danger" @click.prevent="confermaChiusuraTavolo(selectedOrderIdT, selectedOrderIdO)">{{ $t('chiudi_tavolo') || 'Chiudi Tavolo' }}</button>
                <button class="btn btn-outline-danger" @click.prevent="eliminaTavolo(selectedOrderIdT, selectedOrderIdO)">{{ $t('elimina_tavolo') || 'Elimina Tavolo' }}</button>
            </div>
        </div>
    </div>

    <!-- Modal Fattura Elettronica -->
    <div class="coperti-modal-overlay" v-if="showFatturaModal">
        <div class="cont_conto" style="background-color: #2c3e50; border-radius: 12px; padding: 20px; color: white; width: 700px; max-width: 95vw;">
            <div style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #555; padding-bottom: 10px; margin-bottom: 20px;">
                <h3 style="margin: 0; background: none;">Fattura Elettronica</h3>
                <span @click="showFatturaModal = false" style="background: #e74c3c; padding: 5px 15px; border-radius: 6px; cursor: pointer;">{{ $t('exit') || 'X' }}</span>
            </div>
            
            <div style="margin-bottom: 20px; position: relative;">
                <label>Cerca Cliente (Ragione Sociale o P.IVA):</label>
                <input type="text" v-model="searchTextCliente" @input="cercaCliente" placeholder="Inizia a scrivere..." class="form-control" style="color: black; background: white;" />
                <div v-if="clientiTrovati.length" style="position: absolute; top: 100%; left: 0; right: 0; background: white; color: black; z-index: 1000; border-radius: 0 0 8px 8px; box-shadow: 0 4px 10px rgba(0,0,0,0.3); max-height: 200px; overflow-y: auto;">
                    <div v-for="c in clientiTrovati" :key="c._id" @click="selezionaCliente(c)" style="padding: 10px; border-bottom: 1px solid #eee; cursor: pointer;">
                        <b>{{ c.ragioneSociale }}</b> - {{ c.partitaIva || c.codiceFiscale }}
                    </div>
                </div>
            </div>

            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 15px; margin-bottom: 20px;">
                <div style="grid-column: span 2;">
                    <label>Ragione Sociale *:</label>
                    <input type="text" v-model="clienteCorrente.ragioneSociale" class="form-control" style="color: black; background: white;" />
                </div>
                <div>
                    <label>Partita IVA:</label>
                    <input type="text" v-model="clienteCorrente.partitaIva" class="form-control" style="color: black; background: white;" />
                </div>
                <div>
                    <label>Codice Fiscale:</label>
                    <input type="text" v-model="clienteCorrente.codiceFiscale" class="form-control" style="color: black; background: white;" />
                </div>
                <div>
                    <label>Indirizzo *:</label>
                    <input type="text" v-model="clienteCorrente.indirizzo" class="form-control" style="color: black; background: white;" />
                </div>
                <div>
                    <label>CAP *:</label>
                    <input type="text" v-model="clienteCorrente.cap" class="form-control" style="color: black; background: white;" />
                </div>
                <div>
                    <label>Comune *:</label>
                    <input type="text" v-model="clienteCorrente.comune" class="form-control" style="color: black; background: white;" />
                </div>
                <div>
                    <label>Provincia (2 Lettere) *:</label>
                    <input type="text" v-model="clienteCorrente.provincia" maxlength="2" class="form-control" style="color: black; background: white;" />
                </div>
                <div>
                    <label>Codice Destinatario:</label>
                    <input type="text" v-model="clienteCorrente.codiceDestinatario" maxlength="7" class="form-control" style="color: black; background: white;" />
                </div>
                <div>
                    <label>PEC:</label>
                    <input type="text" v-model="clienteCorrente.pec" class="form-control" style="color: black; background: white;" />
                </div>
            </div>

            <div style="text-align: center;">
                <button class="btn btn-success btn-lg" @click="inviaFatturaElettronica" :disabled="loadingFattura">
                    {{ loadingFattura ? 'Invio in corso...' : 'Invia Fattura Elettronica' }}
                </button>
            </div>
        </div>
    </div>

    <!-- Password Prompt Custom Modal -->
    <div class="coperti-modal-overlay" v-if="passwordPrompt.show" style="z-index: 30000;">
        <div class="cont_conto" style="background-color: #2c3e50; border-radius: 12px; padding: 20px; color: white; width: 350px; margin: auto;">
            <div style="margin-bottom: 15px;">
                <label style="font-weight: bold; display: block; margin-bottom: 8px;">{{ passwordPrompt.message }}</label>
                <input type="password" class="form-control" v-model="passwordPrompt.inputPassword" @keyup.enter="confermaPasswordPrompt" style="color: black;" />
            </div>
            <div style="display: flex; gap: 10px; justify-content: flex-end;">
                <button class="btn btn-secondary" @click.prevent="annullaPasswordPrompt">Annulla</button>
                <button class="btn btn-danger" @click.prevent="confermaPasswordPrompt">Conferma</button>
            </div>
        </div>
    </div>

    <!-- Modal Coperti -->
    <div class="coperti-modal-overlay" v-if="showCopertiModal">
      <div class="coperti-modal-box">
        <h5>Inserisci Coperti</h5>
        <p>Quanti coperti per il tavolo <b>{{tempTavolo}}</b>?</p>
        <input type="number" min="1" v-model.number="inputCoperti" class="form-control" placeholder="Nr Coperti" />
        <div style="display:flex; gap:10px; margin-top:15px; justify-content:flex-end;">
          <button class="btn btn-secondary btn-sm" @click="showCopertiModal = false">Annulla</button>
          <button class="btn btn-success btn-sm" @click="confermaCoperti">Conferma</button>
        </div>
      </div>
    </div>

    <!-- Modal Avanzamento Portata -->
    <div class="coperti-modal-overlay" v-if="showAvanzamentoModal">
      <div class="coperti-modal-box">
        <h5>Manda in Marcia Portata</h5>
        <p>Seleziona la portata da inviare in cucina per il tavolo <b>{{ordineSelezionato ? ordineSelezionato.t : ''}}</b>:</p>
        <div class="list-group">
          <button 
            v-for="p in portateDisponibili" 
            :key="p" 
            class="list-group-item list-group-item-action"
            @click="confermaAvanzamento(p)"
          >
            {{p}}° Portata
          </button>
        </div>
        <div style="display:flex; gap:10px; margin-top:15px; justify-content:flex-end;">
          <button class="btn btn-secondary btn-sm" @click="showAvanzamentoModal = false">Annulla</button>
        </div>
      </div>
    </div>

    <!-- Modal Evadi Chiamata Cameriere -->
    <div class="coperti-modal-overlay" v-if="showEvadiModal">
      <div class="coperti-modal-box" style="text-align: center;">
        <h5 style="color: #e74c3c;">{{ $t('chiamata_cameriere') || 'Chiamata Cameriere' }}</h5>
        <p style="font-size: 1.2rem; margin: 20px 0;">{{ $t('chiamata_evasa') || 'Chiamata evasa?' }}</p>
        <div style="display:flex; gap:15px; justify-content:center; margin-top:20px;">
          <button class="btn btn-secondary" @click="showEvadiModal = false">{{ $t('no') || 'No' }}</button>
          <button class="btn btn-danger" @click="evadiChiamata">{{ $t('si') || 'Sì' }}</button>
        </div>
      </div>
    </div>

    <!-- Modal Lista Prenotati -->
    <div class="coperti-modal-overlay" v-if="showPrenotatiModal">
      <div class="prenotati-modal-box">
        <div class="modal-header">
          <h5>{{ $t('lista_prenotati') }}</h5>
          <button class="close-btn" @click="showPrenotatiModal = false">&times;</button>
        </div>
        <div class="modal-body">
          <table class="table table-sm">
            <thead>
              <tr>
                <th>{{ $t('nome') }}</th>
                <th>{{ $t('telefono') }}</th>
                <th>{{ $t('coperti') }}</th>
                <th>{{ $t('ora') }}</th>
                <th>{{ $t('sala') }}</th>
                <th>{{ $t('tavolo') }}</th>
                <th>{{ $t('stato') }}</th>
                <th>{{ $t('azioni') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="p in dailyBookings" :key="p._id">
                <td>{{ p.nome }} {{ p.cognome }}</td>
                <td>{{ p.telefono }}</td>
                <td>{{ p.coperti }}</td>
                <td>{{ moment.unix(p.tm / 1000).format('HH:mm') }}</td>
                <td>{{ sala }}</td>
                <td>
                  <select v-model="p.selectedTavolo" class="form-control form-control-sm" :disabled="p.associato">
                    <option v-for="t in tavoli" :key="t" :value="t">T{{ t }}</option>
                  </select>
                </td>
                <td>
                  <span :class="p.associato ? 'text-success' : 'text-danger'">
                    {{ p.associato ? $t('associato') : $t('non_associato') }}
                  </span>
                </td>
                <td>
                  <button v-if="!p.associato" class="btn btn-success btn-sm" @click="associaBooking(p)">OK</button>
                  <button class="btn btn-danger btn-sm" @click="eliminaBooking(p._id)">{{ $t('elimina') }}</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="coperti-modal-overlay" v-if="showBookingModal">
      <div class="coperti-modal-box">
        <h5>{{ $t('prenota_tavolo') }} - {{ $t('tavolo') }} {{tavolo}}</h5>
        
        <div class="input-group mb-3 mt-3">
            <div class="input-group-prepend">
                <span class="input-group-text">{{ $t('nome') }}</span>
            </div>
            <input v-model="nome" type="text" class="form-control" :placeholder="$t('nome') || 'Nome'">
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text">{{ $t('cognome') }}</span>
            </div>
            <input v-model="cognome" type="text" class="form-control" :placeholder="$t('cognome') || 'Cognome'">
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text">{{ $t('telefono') }}</span>
            </div>
            <input v-model="telefono" type="text" class="form-control" :placeholder="$t('telefono') || 'Telefono'">
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text">{{ $t('coperti') }}</span>
            </div>
            <input v-model="coperti" type="text" class="form-control" :placeholder="$t('nr_coperti') || 'Nr Coperti'">
        </div>

        <div style="display:flex; gap:10px; margin-top:20px; justify-content:flex-end;">
          <button class="btn btn-secondary btn-sm" @click="showBookingModal = false">{{ $t('annulla', 'Annulla') }}</button>
          <button class="btn btn-success btn-sm" @click="prenotaTavolo">{{ $t('conferma', 'Conferma') }}</button>
        </div>
      </div>
    </div>

</div>
</template>

<script>
// @ is an alias to /src
import moment from 'moment'
import { io } from "socket.io-client"
import { store } from '../store/store.js'
  //const URL = "http://localhost:5000";
  //const socket = io(URL, { autoConnect: true });

export default {
    name: 'VisualizzaSala',
    /*props: {
        sala: String,
        numero:Number
    },*/
        data: function () {
            return {
                tavoli:[],
                tavolo:'',
                date: new Date(),
                sala: this.$route.params.nome, // sala attuale
                sale:this.$route.params.sale, // passo parametri nomi sale
                numeroSale: this.$route.params.numeroSale, // parametro capienza sale 
                numero:this.$route.params.numero, // sala attuale
                nome:'',  // prenotazioni
                cognome:'', // prenotazioni
                telefono:'', // prenotazioni
                moment:'', 
                coperti:'', // prenotazioni
                ordinazione:[],
                prenotazioni:[], //singolo tavolo
                prodotti:[],
                bgActive:'#c7c2c2',
                bgInactive:'#ffffff',
                totale:'',
                tab:{
                    ordinazioni:false,
                    prenotazioni:false,
                    prenT:false
                },
                prenotazionisala:[],  // intera sala
                ordini:[], // interna sala
                socket:io(process.env.VUE_APP_SOCKET_URL, { autoConnect: true }),
                store,
                showModal: false,
                sconto: 0,
                numeroDivisione: 1,
                selectedOrderIdT: null,
                selectedOrderIdO: null,
                metodoPagamento: 'contante',
                emailScontrino: '',
                showCopertiModal: false,
                tempTavolo: '',
                inputCoperti: 1,
                showAvanzamentoModal: false,
                ordineSelezionato: null,
                portateDisponibili: [],
                chiamateCameriere: [], // Array di objects { sala, tavolo }
                showEvadiModal: false,
                tavoloDaEvadere: null,
                showPrenotatiModal: false,
                dailyBookings: [],
                unassociatedCount: 0,
                printObj: {
                    url: process.env.VUE_APP_PRINTER_URL,
                    beforeOpenCallback () {
                        console.log('打开之前')
                    },
                    openCallback () {
                        console.log('执行了打印')
                    },
                    closeCallback () {
                        console.log('关闭了打印工具')
                    }
                },
                ritardiMarcia: [],
                asportoNotifications: [],
                notifInterval: null,
                costoCoperto: 0,
                modalita: 'servizio',
                showBookingModal: false,
                showFatturaModal: false,
                clienteCorrente: {
                    ragioneSociale: '',
                    partitaIva: '',
                    codiceFiscale: '',
                    indirizzo: '',
                    cap: '',
                    comune: '',
                    provincia: '',
                    codiceDestinatario: '0000000',
                    pec: ''
                },
                searchTextCliente: '',
                clientiTrovati: [],
                loadingFattura: false,
                passwordPrompt: {
                    show: false,
                    message: '',
                    inputPassword: '',
                    resolve: null,
                    reject: null
                }
            }

        },
    methods: {
        formatAggiunte(list) {
            if (!list || !list.length) return '';
            return list.map(a => typeof a === 'object' ? (a.descrizione || a.nome || a.prodottoId || '') : String(a)).filter(Boolean).join(', ');
        },
        getSettings() {
            this.axios.get(this.store.path + 'impostazioni/69c90e57851daafaf559b837', {
                headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
            }).then(response => {
                const data = response.data;
                if (data && data.costoCoperto !== undefined) {
                    this.costoCoperto = data.costoCoperto;
                }
            }).catch(error => {
                console.error("Errore nel caricamento del costo coperto:", error);
            });
        },
        async verificaPasswordAdmin() {
            try {
                const responseSettings = await this.axios.get(this.store.path + 'impostazioni/69c90e57851daafaf559b837', {
                    headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
                });
                if (responseSettings.data && responseSettings.data.passwordAdmin) {
                    const passwordAdmin = responseSettings.data.passwordAdmin;
                    const input = await this.richiediPasswordAdmin("Inserisci la password amministratore per procedere:");
                    if (input === null) {
                        return { authorized: false };
                    }
                    if (input !== passwordAdmin) {
                        alert("Password amministratore errata!");
                        return { authorized: false };
                    }
                    return { authorized: true, password: input };
                }
                return { authorized: true, password: '' }; // Se non c'è una password impostata, consentiamo
            } catch (err) {
                console.error("Errore verifica password admin:", err);
                return { authorized: false };
            }
        },
        richiediPasswordAdmin(message = "Inserisci la password amministratore:") {
            return new Promise((resolve, reject) => {
                this.passwordPrompt.message = message;
                this.passwordPrompt.inputPassword = '';
                this.passwordPrompt.show = true;
                this.passwordPrompt.resolve = resolve;
                this.passwordPrompt.reject = reject;
            });
        },
        confermaPasswordPrompt() {
            if (this.passwordPrompt.resolve) {
                this.passwordPrompt.resolve(this.passwordPrompt.inputPassword);
            }
            this.passwordPrompt.show = false;
        },
        annullaPasswordPrompt() {
            if (this.passwordPrompt.resolve) {
                this.passwordPrompt.resolve(null);
            }
            this.passwordPrompt.show = false;
        },
        async rimuoviPiattoDalTavolo(idO, piattoId) {
            if (!piattoId) {
                alert("Non è possibile eliminare questo elemento.");
                return;
            }
            const authResult = await this.verificaPasswordAdmin();
            if (!authResult.authorized) return;

            this.axios.post(this.store.path + 'rimuoviPiattoDaOrdine', { 
                idOrdine: idO, 
                piattoId: piattoId,
                passwordAdmin: authResult.password
            }, {
                headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
            }).then(response => {
                if (response.data) {
                    alert("Piatto eliminato dal tavolo.");
                    this.displayOrdine();
                }
            }).catch(error => {
                console.error(error);
                alert("Errore durante l'eliminazione del piatto.");
            });
        },
        async eliminaTavolo(idT, idO) {
            const authResult = await this.verificaPasswordAdmin();
            if (!authResult.authorized) return;

            if (confirm("Sei sicuro di voler eliminare l'intero tavolo/ordine? Questa azione non può essere annullata.")) {
                this.axios.post(this.store.path + 'eliminaOrdine', { 
                    idOrdine: idO,
                    passwordAdmin: authResult.password
                }, {
                    headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
                }).then(response => {
                    if (response.data) {
                        alert("Tavolo eliminato.");
                        this.showModal = false;
                        this.ordinazione = [];
                        this.displayOrdini();
                    }
                }).catch(error => {
                    console.error(error);
                    alert("Errore durante l'eliminazione del tavolo.");
                });
            }
        },
        /*getTavoli() {
            this.axios.post(this.store.path+'caricaTavoli',{nome:this.nome,numero:this.numero}).then((response) => {
            // axios.defaults.headers.common['Authorization'] = 'Bearer ' + r.data.token;
            //localStorage.setItem( 'token', JSON.stringify(response.data.token) );
            //this.$router.push({ name: "Gestionale", params :{data:`Ben Tornato ${this.nomeUtente}`,token: response.data.token} })
                if(response.data){
                    console.log('Sale Salvata correttamente')
                }else{console.log('Non è stato possibile Creare la sala')}
            })
        }*/
        displayProduct() {
            this.axios.post(this.store.path+'displayProduct',{headers:{
            authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            console.log(response.data.messaggio)
            if(response.data.messaggio){
                console.log('Prodotti caricati con successo')
            }else{console.log('Non è stato possibile caricare i prodotti')}
            response.data.messaggio.forEach(element => {
                  this.prodotti.push(element);
            });
            })
        },
        getTavoli(){
            //console.log(typeof this.$route.params.numero)
            let numeroTavoli = parseInt(this.numero,10);
            for (let i=1; i <= numeroTavoli; i++){
                //console.log(this.props.numero)
                    this.tavoli.push(i)
            }
        },
        getStato () {

        },
        printOrdine () {
            
        },
        home() {
            this.$router.push({ name: "Gestionale"})
        },
        cercaCliente() {
            if (this.searchTextCliente.length < 3) {
                this.clientiTrovati = [];
                return;
            }
            this.axios.post(this.store.path + 'cliente/list', { search: this.searchTextCliente }, {
                headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
            }).then(response => {
                this.clientiTrovati = response.data;
            });
        },
        selezionaCliente(cliente) {
            this.clienteCorrente = { ...cliente };
            this.clientiTrovati = [];
            this.searchTextCliente = cliente.ragioneSociale;
        },
        async inviaFatturaElettronica() {
            if (!this.clienteCorrente.ragioneSociale || !this.clienteCorrente.indirizzo || !this.clienteCorrente.cap || !this.clienteCorrente.comune || !this.clienteCorrente.provincia) {
                alert("Compila tutti i campi obbligatori (*)");
                return;
            }

            this.loadingFattura = true;
            try {
                // 1. Salva/Aggiorna Cliente
                await this.axios.post(this.store.path + 'cliente/upsert', this.clienteCorrente, {
                    headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
                });

                // 2. Genera e Invia Fattura
                const response = await this.axios.post(this.store.path + 'fattura/generate', {
                    orderData: {
                        totale: this.totale,
                        ord: this.ordinazione.reduce((acc, curr) => acc.concat(curr.ord), [])
                    },
                    cliente: this.clienteCorrente,
                    paymentType: this.metodoPagamento,
                    discount: this.sconto
                }, {
                    headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
                });

                if (response.data && response.data.errorCode === 0) {
                    alert("Fattura elettronica inviata con successo!");
                    this.pagaTavolo(this.selectedOrderIdT, this.selectedOrderIdO);
                    this.showFatturaModal = false;
                    this.showModal = false;
                } else {
                    alert("Errore nell'invio della fattura: " + (response.data.errorMessage || "Errore sconosciuto"));
                }
            } catch (error) {
                console.error("Errore Fattura:", error);
                alert("Errore nell'invio della fattura: " + (error.response?.data?.message || error.message));
            } finally {
                this.loadingFattura = false;
            }
        },
        showTab(e) {
            var tab = e.target.id;
            if (tab == 'prenotazioni') {
                this.tab.prenotazioni = true;
                this.tab.prenT= false;
                this.tab.ordinazioni = false;
            }
            if(tab== 'pren-t'){
                this.tab.prenT = true;
                this.tab.ordinazioni = false;
                this.tab.prenotazioni= false;
            }
            if(tab == 'ordini') {
                this.tab.ordinazioni = true;
                this.tab.prenT= false;
                this.tab.prenotazioni= false;
                this.displayOrdine();
            }
        },

        displayOrdine(){
            this.moment = moment;
            var end = moment(this.date).endOf('day').unix();
            var start = moment(this.date).startOf('day').unix();
            var data = moment(this.date).format('DD');
            var rv= [];
            var totale = 0;
            this.axios.post(this.store.path+'displayOrdine',{codtavolo:this.tavolo,sala:this.sala,end:end,start:start,singolo:true,headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}})
.then((response) => {
                if(response.data){
                    response.data.messaggio.forEach(element => {
                        element.ordine.forEach(ord => {
                            let itemCostoAggiunta = 0;
                            if (ord.aggiunta && ord.aggiunta.length) {
                                ord.aggiunta.forEach(aggiunta => {
                                    let pPrice = 0;
                                    if (typeof aggiunta === 'object' && (aggiunta.prezzo !== undefined || aggiunta.prezzoAggiunta !== undefined)) {
                                        pPrice = Number(aggiunta.prezzo || aggiunta.prezzoAggiunta) || 0;
                                    } else {
                                        const desc = typeof aggiunta === 'object' ? (aggiunta.descrizione || aggiunta.nome || '') : String(aggiunta);
                                        const code = typeof aggiunta === 'object' ? (aggiunta.prodottoId || aggiunta.code || '') : '';
                                        const prod = (this.prodotti || []).find(o => (code && o.code === code) || o.descrizio === desc || o.nome === desc);
                                        if (prod && prod.prezzoAggiunta) {
                                            pPrice = Number(prod.prezzoAggiunta) || 0;
                                        }
                                    }
                                    itemCostoAggiunta += pPrice;
                                });
                            }
                            ord.costoAggiunta = itemCostoAggiunta;
                            totale = totale + ((ord.costoAggiunta ? ord.costoAggiunta : 0) + ord.prezzo) * (ord.quantita || 1);
                        })
                        
                        // Aggiunge il coperto come voce
                        if (this.costoCoperto > 0 && element.coperti > 0) {
                            element.ordine.push({
                                piatto: 'Coperto',
                                quantita: element.coperti,
                                prezzo: this.costoCoperto * element.coperti,
                                aggiunta: [],
                                senza: [],
                                ordine: '99',
                                nota: '',
                                costoAggiunta: 0
                            });
                            totale += (this.costoCoperto * element.coperti);
                        }

                        // Sort by course (ordine field: "1° portata", "2° portata", etc.)
                        element.ordine.sort((a,b) => {
                            const getNum = (s) => parseInt(s) || 100; // handle "altro" or missing
                            return getNum(a.ordine) - getNum(b.ordine);
                        });
                            
                        
                        rv.push({idT:element.idTavolo,idO:element.idOrdine,t:element.tavolo, ord:element.ordine,tm:data, avanzamento: element.avanzamento, coperti: element.coperti})
                    });
                    this.totale = totale;
                    this.ordinazione= [...rv];
                    localStorage.setItem('ordinazioni', JSON.stringify(rv));
                    console.log('Ordine Presente Per Questa Data')
                }else{console.log('Nessun Ordine Presente Per Questo Tavolo')}
            })

        },

        displayOrdini(){
            this.moment = moment;
            var end = moment(this.date).endOf('day').unix();
            var start = moment(this.date).startOf('day').unix();
            var rv= [];
            this.axios.post(this.store.path+'displayOrdini',{codicesala:this.sala,end:end,start:start,stato:'ordinato',headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            if(response.data){
                console.log(response.data);
                response.data.messaggio.forEach(function(el){
                    console.log(el);
                    rv.push(el);
                })
                this.ordini =rv;
            }else{console.log('Non è Stato Possibile Caricare gli Ordini')}
            })

        },
        pagaTavolo (idT,idO) {
            const isDigitale = this.metodoPagamento === 'digitale';
            this.axios.post(this.store.path+'chiudiOrdine',{
                idT: idT,
                idO: idO,
                totale: this.totale,
                sconto: this.sconto || 0,
                digitale: isDigitale,
                headers: {
                    authorization: `Bearer  ${JSON.parse(localStorage.token)}`
                }
            }).then((response) => {
                if(response.data){
                    console.log(response.data)
                    this.ordinazione=[];
                    this.displayOrdini()
                    this.showModal = false;
                }else{console.log('Nessun Ordine Presente Per Questo Tavolo')}
            })
        },
        printPaper(idT,idO,tipo,ordinazione) {
            console.log("printPaper requested:", tipo);
            const { ipcRenderer } = window.require ? window.require('electron') : { ipcRenderer: null };
            
            if (ipcRenderer && ordinazione.length) {
                var whereIcanPrint = []
                this.axios.post(this.store.path+'displaySpecificPrinter',{nome:'cassa',headers:{
                authorization: `Bearer  ${JSON.parse(localStorage.token)}`}})
                .then((response) => {
                    if(response.data.messaggio){
                        response.data.messaggio.forEach(element => {
                            whereIcanPrint.push({id:element._id,nome:element.nome, ip:element.ip,porta:element.porta,postazioni:element.postazioni})
                        });
                        
                        const sanitizedOrdinazione = JSON.parse(JSON.stringify(ordinazione));
                        whereIcanPrint.forEach(element => {
                            ipcRenderer.send('print', sanitizedOrdinazione, { ip: element.ip, porta: element.porta }, 'cassa', this.sconto);
                        });
                    }
                    if(tipo !='preconto'){
                        this.pagaTavolo(idT,idO);
                    }
                });
            } else {
                console.log('Direct printing not available in web app. Closing table.');
                if(tipo !='preconto'){
                    this.pagaTavolo(idT,idO);
                }
            }
        },
        inviaScontrinoElettronico() {
            if (!this.ordinazione.length) return;
            const ordine = this.ordinazione[0]; // In cli, ordinazione is for the selected table
            
            const data = {
                orderData: {
                    idO: this.selectedOrderIdO,
                    t: ordine.t,
                    ord: ordine.ord,
                    totale: this.totale
                },
                paymentType: this.metodoPagamento,
                email: this.emailScontrino,
                discount: this.sconto
            };

            this.axios.post(this.store.path + 'scontrino/generate', data, {
                headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
            }).then(() => {
                alert("Scontrino elettronico inviato con successo!");
                this.pagaTavolo(this.selectedOrderIdT, this.selectedOrderIdO);
                this.showModal = false;
            }).catch(error => {
                const msg = error.response?.data?.message || "Errore durante l'invio dello scontrino.";
                alert("Errore: " + msg);
            });
        },
        chiudiTavolo (idT,idO) {
            console.log("Opening close table modal for:", idT, idO);
            this.selectedOrderIdT = idT;
            this.selectedOrderIdO = idO;
            this.showModal = true;
        },
        confermaChiusuraTavolo(idT, idO) {
            if (confirm("Sei sicuro di voler chiudere il tavolo?")) {
                this.pagaTavolo(idT, idO);
                this.showModal = false;
            }
        },
        selezionaTavolo(e) {
            this.ordinazione = "";
            console.log(e.target.id);
            console.log(this.date);
            this.tavolo=e.target.id;

            // Se il tavolo ha una chiamata cameriere attiva, apri la modale di evasione
            // Normalizziamo l'ID del tavolo cliccato (togliendo l'eventuale 't')
            let clickedTableId = String(e.target.id);
            if (clickedTableId.startsWith('t')) clickedTableId = clickedTableId.slice(1);

            const hasChiamata = this.chiamateCameriere.some(c => {
                const sameSala = c.sala.trim().toLowerCase() === this.sala.trim().toLowerCase();
                let savedTableId = String(c.tavolo);
                if (savedTableId.startsWith('t')) savedTableId = savedTableId.slice(1);
                
                return sameSala && savedTableId === clickedTableId;
            });

            if (hasChiamata) {
                this.tavoloDaEvadere = e.target.id; // Manteniamo l'ID originale per la classe CSS
                this.showEvadiModal = true;
            }

            // Controlla se il tavolo ha un ordine attivo
            const hasActiveOrder = this.ordini.some(tav => {
                if (tav.codicesala !== this.sala) return false;
                let num = String(tav.numero);
                if (num.startsWith('t')) num = num.slice(1);
                return num === clickedTableId;
            });

            if (this.modalita === 'preparazione') {
                // In modalità preparazione, apre la modale per prenotare il tavolo
                this.showBookingModal = true;
            } else {
                // In modalità servizio
                if (hasActiveOrder) {
                    this.tab.ordinazioni = true;
                    this.tab.prenT = false;
                    this.tab.prenotazioni = false;
                    this.displayOrdine();
                } else {
                    this.tab.ordinazioni = false;
                    // Se non ha un ordine associato, apre la modale per inserire i coperti
                    this.aggiungiPiatti(e.target.id);
                }
            }
        },
        apriEvadiChiamata(c) {
            this.tavoloDaEvadere = String(c.tavolo).startsWith('t') ? c.tavolo : `t${c.tavolo}`;
            this.showEvadiModal = true;
        },
        parseWaitTime(timeStr) {
            if (!timeStr) return 0;
            const parts = String(timeStr).split(':');
            if (parts.length !== 2) return 0;
            return parseInt(parts[0]) * 60 + parseInt(parts[1]);
        },
        fetchNotifications() {
            // 1. Ritardi Marcia
            this.axios.post(this.store.path + 'displayMarcia', {
                headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
            }).then(response => {
                if (response.data && response.data.messaggio) {
                    const now = Date.now() / 1000;
                    this.ritardiMarcia = response.data.messaggio.map(m => {
                        const waitSecs = this.parseWaitTime(m.tempo_di_attesa);
                        const expectedEnd = m.tm + waitSecs;
                        const isLate = now > expectedEnd;
                        return { ...m, isLate, ritardoSecs: Math.floor(now - expectedEnd) };
                    }).filter(m => m.isLate);
                }
            }).catch(err => console.error("Error fetching marcia:", err));

            // 2. Nuovi Asporto
            const today = new Date().toISOString().split('T')[0];
            this.axios.post(this.store.path + 'getOrdiniAsporto', {
                pagato: true,
                data: today,
                stato: 'pagato',
                headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
            }).then(response => {
                if (response.data && response.data.messaggio) {
                    this.asportoNotifications = response.data.messaggio;
                }
            }).catch(err => console.error("Error fetching asporto notif:", err));
        },
        evadiChiamata() {
            if (!this.tavoloDaEvadere) return;

            let targetId = String(this.tavoloDaEvadere);
            if (targetId.startsWith('t')) targetId = targetId.slice(1);
            
            this.chiamateCameriere = this.chiamateCameriere.filter(c => {
                const isDifferentSala = c.sala.trim().toLowerCase() !== this.sala.trim().toLowerCase();
                let savedId = String(c.tavolo);
                if (savedId.startsWith('t')) savedId = savedId.slice(1);
                
                return isDifferentSala || savedId !== targetId;
            });
            
            localStorage.setItem('chiamateCameriere', JSON.stringify(this.chiamateCameriere));
            
            // Rimuovi la classe visiva
            const element = document.getElementById(`${this.tavoloDaEvadere}`);
            if (element) element.classList.remove("cameriere");
            
            this.showEvadiModal = false;

            // Invia evento socket di evasion
            this.socket.emit('evasioneChiamata', { sala: this.sala, tavolo: this.tavoloDaEvadere });

            this.tavoloDaEvadere = null;
            console.log('✅ Chiamata evasa e rimossa dal localStorage con normalizzazione ID');
        },
        applyCameriereStyles() {
            // Pulisci prima tutti i tavoli dalle classi cameriere per sicurezza
            this.tavoli.forEach(tav => {
                const element = document.getElementById(`${tav}`);
                if (element) element.classList.remove("cameriere");
            });

            // Applica stili per le chiamate salvate nella sala corrente
            this.chiamateCameriere.forEach(c => {
                if (c.sala.trim().toLowerCase() === this.sala.trim().toLowerCase()) {
                    let tableId = c.tavolo;
                    if (typeof tableId === 'string' && tableId.startsWith('t')) {
                        tableId = tableId.slice(1);
                    }
                    const element = document.getElementById(`${tableId}`);
                    if (element) element.classList.add("cameriere");
                }
            });
        },
        prenotaTavolo() {
            this.moment = moment;
            //var end = moment(this.date).endOf('day').unix();
            //var start = moment(this.date).startOf('day').unix();
            var data = moment(this.date).unix();
            this.axios.post(this.store.path+'prenotaTavolo',{nome:this.nome,cognome:this.cognome,telefono:this.telefono,codicesala:this.sala,tavolo:this.tavolo,coperti:this.coperti,tm:data,stato:'prenotato',headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            // axios.defaults.headers.common['Authorization'] = 'Bearer ' + r.data.token;
            //localStorage.setItem( 'token', JSON.stringify(response.data.token) );
            //this.$router.push({ name: "Gestionale", params :{data:`Ben Tornato ${this.nomeUtente}`,token: response.data.token} })
                if(response.data){
                    this.prenotazionisala.push({numero:this.tavolo})
                    console.log(response.data.messaggio)
                    this.tavolo='';
                    this.nome='';
                    this.cognome='';
                    this.coperti='';
                    this.telefono='';
                    this.prenotazioni= [response.data.messaggio];
                    this.showBookingModal = false;
                    console.log('Tavolo Prenotato')
                }else{console.log('Non è Stato Possibile prenotare il Tavolo')}
            })

        },
        displayPrenotazioni() {
        var prenotazioni =[];
        this.moment = moment;
        var end = moment(this.date).endOf('day').unix();
        var start = moment(this.date).startOf('day').unix();
        //var data = moment(this.date).unix();
        console.log('la richiesta è inviata')
        this.axios.post(this.store.path+'displayPrenotazioni',{end:end,start:start,codicesala:this.sala,stato:'prenotato',headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            if(response.data){
                console.log(response.data);
                response.data.messaggio.forEach(function(el){
                    console.log(el);
                    prenotazioni.push(el);
                })
                this.prenotazionisala = prenotazioni;
            }else{console.log('Non è Stato Possibile prenotare il Tavolo')}
        })

    },
    cambiaSala (sala,numero) {
        this.tavoli=[];
        this.sala = sala;
        this.numero = numero;
        this.getTavoli();
        this.displayPrenotazioni();
        this.displayOrdini();
        // Applica i colori rossi caricati dal localStorage
        this.$nextTick(() => {
            this.applyCameriereStyles();
        });
    },
    goToAsportoStaff() {
        this.$router.push({ name: "OrdineAsporto", query: { mode: 'staff' } })
    },
    aggiungiPiatti(tavoloNum) {
        if (!this.coperti || parseInt(this.coperti) <= 0) {
            this.tempTavolo = tavoloNum;
            this.inputCoperti = 1;
            this.showCopertiModal = true;
            return;
        }
        this.procediAggiungiPiatti(tavoloNum, this.coperti);
    },
    confermaCoperti() {
        if (!this.inputCoperti || this.inputCoperti <= 0) {
            alert('Inserisci un numero di coperti valido');
            return;
        }
        this.coperti = this.inputCoperti;
        this.showCopertiModal = false;
        this.procediAggiungiPiatti(this.tempTavolo, this.inputCoperti);
    },
    procediAggiungiPiatti(tavoloNum, coperti) {
        let tavoloStr = String(tavoloNum).startsWith('t') ? String(tavoloNum) : 't' + tavoloNum;
        let ordData = { 
            sala: this.sala, 
            tavolo: tavoloStr, 
            coperti: coperti,
            numero: this.numero,
            sale: this.sale,
            numeroSale: this.numeroSale
        };
        localStorage.setItem('ordineAttuale', JSON.stringify(ordData));
        this.$router.push({ name: 'Menu' });
    },
    apriAvanzamentoModal(ordine) {
        this.ordineSelezionato = ordine;
        // Estrarre portate presenti (2-6) che hanno piatti nell'ordinazione
        const tuttePortate = [2, 3, 4, 5, 6];
        this.portateDisponibili = tuttePortate.filter(num => {
            const label = `${num}° portata`;
            const labelShort = `${num}°`;
            // Deve esserci nel menu
            const presenteNelMenu = ordine.ord.some(p => p.ordine === label || p.ordine === labelShort);
            // Non deve essere già in marcia
            const giaInMarcia = ordine.avanzamento && ordine.avanzamento.some(a => a.portata === num);
            
            return presenteNelMenu && !giaInMarcia;
        });

        if (this.portateDisponibili.length === 0) {
            alert("Nessuna portata successiva da mandare in marcia.");
            return;
        }

        this.showAvanzamentoModal = true;
    },
    confermaAvanzamento(portataNum) {
        this.confermaAvanzamentoManuale(this.ordineSelezionato, portataNum);
        this.showAvanzamentoModal = false;
    },
    confermaAvanzamentoManuale(ordine, portataNum) {
        if (!confirm(`Sei sicuro di voler mandare in marcia la ${portataNum}° portata?`)) return;

        this.axios.post(this.store.path + 'avanzaPortata', {
            ordineId: ordine.idO,
            portata: portataNum,
            headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
        }).then((response) => {
            if (response.data) {
                alert(`Portata ${portataNum}° inviata in cucina. Tempo attesa: ${response.data.tempo_di_attesa}`);
                this.displayOrdine(); 
            }
        }).catch(err => {
            console.error("Errore avanzamento:", err);
            alert("Errore durante l'invio della portata.");
        });
    },
    getActiveAdv(ordine) {
        if (!ordine.avanzamento) return null;
        return ordine.avanzamento.find(a => a.stato_avanzamento === 'in_marcia');
    },
    getNextPortata(ordine) {
        const portateInOrdine = [1, 2, 3, 4, 5, 6].filter(num => {
            const label = `${num}° portata`;
            const labelShort = `${num}°`;
            return ordine.ord.some(p => p.ordine === label || p.ordine === labelShort);
        });

        // Trova l'ultima portata servita
        const servite = (ordine.avanzamento || [])
            .filter(a => a.stato_avanzamento === 'servito')
            .map(a => a.portata);
        
        const lastServita = servite.length ? Math.max(...servite) : 0;
        
        // La prossima è la prima in ordine che è maggiore di lastServita
        return portateInOrdine.find(num => num > lastServita);
    },
    haPortateDaAvanzare(ordine) {
        return !!this.getNextPortata(ordine);
    },
    segnaComeServito(ordine, portataNum) {
        const label = portataNum ? `${portataNum}° ` : '';
        if (!confirm(`Segnare come servita la ${label}portata?`)) return;

        this.axios.post(this.store.path + 'segnaPortataComeServita', {
            ordineId: ordine.idO,
            portata: portataNum,
            headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
        }).then((response) => {
            if (response.data) {
                alert("Portata segnata come servita.");
                this.displayOrdine();
            }
        }).catch(err => {
            console.error("Errore segna come servito:", err);
            alert("Errore durante l'aggiornamento dello stato.");
        });
    },
    generaPagamentoStripe(idT, idO) {
        if (!confirm("Vuoi generare un link di pagamento Stripe per questo tavolo?")) return;

        this.axios.post(this.store.path + 'creaSessionePagamentoTavolo', {
            idT: idT,
            idO: idO,
            headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
        }).then((response) => {
            if (response.data && response.data.sessionUrl) {
                // Redirect to Stripe checkout
                window.location.href = response.data.sessionUrl;
            } else {
                alert("Errore nella generazione del link di pagamento.");
            }
        }).catch(err => {
            console.error("Errore Stripe:", err);
            alert("Errore durante la creazione della sessione di pagamento.");
        });
    },
    fetchDailyStatus() {
        this.axios.get(this.store.path + 'prenotazioni-mgmt/stato-associazione', {
            headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
        }).then(res => {
            this.unassociatedCount = res.data.totali - res.data.associate;
        }).catch(err => console.error("Error fetching association status:", err));
    },
    openPrenotatiModal() {
        this.fetchDailyBookings();
        this.showPrenotatiModal = true;
    },
    fetchDailyBookings() {
        this.axios.get(this.store.path + 'prenotazioni-mgmt/giorno', {
            headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
        }).then(res => {
            this.dailyBookings = res.data.map(b => {
                let table = b.selectedTavolo;
                if (!table && b.numero) {
                    table = b.numero;
                    // Rimuovi eventuale prefisso 't' e converti in numero
                    if (typeof table === 'string' && table.startsWith('t')) {
                        table = table.slice(1);
                    }
                    table = parseInt(table);
                }
                return { ...b, selectedTavolo: table || '' };
            });
        }).catch(err => console.error("Error fetching daily bookings:", err));
    },
    associaBooking(booking) {
        if (!booking.selectedTavolo) return alert("Seleziona un tavolo");
        this.axios.post(this.store.path + 'prenotazioni-mgmt/associa', {
            bookingId: booking._id,
            numeroTavolo: booking.selectedTavolo,
            codicesala: this.sala
        }, {
            headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
        }).then(() => {
            this.fetchDailyBookings();
            this.fetchDailyStatus();
            this.displayPrenotazioni();
        }).catch(err => alert(err.response?.data?.message || "Errore associazione"));
    },
    eliminaBooking(id) {
        if (!confirm("Sei sicuro di voler eliminare questa prenotazione?")) return;
        this.axios.delete(this.store.path + `prenotazioni-mgmt/${id}`, {
            headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
        }).then(() => {
            this.fetchDailyBookings();
            this.fetchDailyStatus();
            this.displayPrenotazioni();
        }).catch(() => alert("Errore eliminazione"));
    }
},

    computed : {
      aggiornaOrdine(){
          let data = this.date;
            return data;
        },
        aggiornaStatoT(){
            let prenotazioni = this.prenotazionisala;
            return prenotazioni;
        },
        aggiornaOrdineT(){
            let ordini = this.ordini;
            return ordini
        }
   },
    watch:{
      aggiornaOrdine:{
          deep:true,
          handler:function(val){
              if(val){
                  console.log(val);
                  this.displayPrenotazioni();
                  this.displayOrdini();
                  this.ordinazione="";
                } 
            }
        },
        aggiornaStatoT:{
            deep:true,
            handler:function(val){
                console.log(val.length)
                this.tavoli.forEach(tav => {
                        var element = document.getElementById(`${tav}`);
                        if (element) element.classList.remove('prenotato')
                    });
                if(val.length){
                    val.forEach(tav => {
                        let num = tav.numero;
                        if (typeof num === 'string' && num.startsWith('t')) {
                            num = num.slice(1);
                        }
                        var element = document.getElementById(`${num}`);
                        console.log(element)
                        if (element) element.classList.add("prenotato");
                    });
                }
                
            }
        },
        aggiornaOrdineT:{
            deep:true,
            handler:function(val){
                this.tavoli.forEach(tav => {
                        var element = document.getElementById(`${tav}`);
                        if (element) element.classList.remove('ordinato')
                    });
                if(val.length){
                    val.forEach(tav => {
                        if(tav.codicesala== this.sala){
                            let num = tav.numero;
                            if (typeof num === 'string' && num.startsWith('t')) {
                                num = num.slice(1);
                            }
                            var element = document.getElementById(`${num}`);
                            console.log(element)
                            if (element) element.classList.add("ordinato");
                        }
                       
                    });
                }
                
            }
        },
    },

    mounted() {
        this.displayProduct();
        this.fetchDailyStatus();
        this.socket.on('ricevutoOrdine',(messaggio) => {
            console.log("Socket: ricevutoOrdine", messaggio)
            if(this.sala == messaggio.sala){
                this.displayOrdini();
            }
        })

        this.socket.on('aggiornaPrenotazioniData', (messaggio) => {
            console.log("Socket: aggiornaPrenotazioniData", messaggio)
            // Always refresh independent of room matching, or you can filter if you like
            this.fetchDailyStatus();
            this.fetchDailyBookings();
        })

        // Carica chiamate cameriere salvate
        const savedCalls = localStorage.getItem('chiamateCameriere');
        if (savedCalls) {
            this.chiamateCameriere = JSON.parse(savedCalls);
            this.$nextTick(() => {
                this.applyCameriereStyles();
            });
        }

        // socket cameriere chiamato
        this.socket.on('ricevutaChiamataCameriere',(messaggio) => {
            console.log("Socket: ricevutaChiamataCameriere", messaggio)
            const targetSala = messaggio.sala ? messaggio.sala.trim().toLowerCase() : '';
            const currentSala = this.sala ? this.sala.trim().toLowerCase() : '';

            // Salva nel localStorage a prescindere dalla sala attuale per persistenza globale
            const esisteGia = this.chiamateCameriere.some(c => 
                c.sala.trim().toLowerCase() === targetSala && 
                String(c.tavolo) === String(messaggio.tavolo)
            );

            if (!esisteGia) {
                this.chiamateCameriere.push({
                    sala: messaggio.sala,
                    tavolo: messaggio.tavolo
                });
                localStorage.setItem('chiamateCameriere', JSON.stringify(this.chiamateCameriere));
            }

            if(targetSala === currentSala){
                // Normalize tavolo ID: remove 't' prefix if it exists to match the numeric ID in the DOM
                let tableId = messaggio.tavolo;
                if (typeof tableId === 'string' && tableId.startsWith('t')) {
                    tableId = tableId.slice(1);
                }
                
                var element = document.getElementById(`${tableId}`);
                if (element) {
                    element.classList.add("cameriere");
                    console.log(`✅ Table ${tableId} turned red (cameriere class added)`);
                }
            }
        })

        // socket evasione chiamata cameriere
        this.socket.on('ricevutaEvasioneChiamata',(messaggio) => {
            console.log("Socket: ricevutaEvasioneChiamata", messaggio)
            const targetSala = messaggio.sala ? messaggio.sala.trim().toLowerCase() : '';
            const currentSala = this.sala ? this.sala.trim().toLowerCase() : '';
            
            let targetTableId = String(messaggio.tavolo);
            if (targetTableId.startsWith('t')) targetTableId = targetTableId.slice(1);

            this.chiamateCameriere = this.chiamateCameriere.filter(c => {
                const isDifferentSala = c.sala.trim().toLowerCase() !== targetSala;
                let savedId = String(c.tavolo);
                if (savedId.startsWith('t')) savedId = savedId.slice(1);
                
                return isDifferentSala || savedId !== targetTableId;
            });
            
            localStorage.setItem('chiamateCameriere', JSON.stringify(this.chiamateCameriere));

            if(targetSala === currentSala){
                // Rimuovi la classe visiva
                const element = document.getElementById(`${targetTableId}`);
                if (element) element.classList.remove("cameriere");
                console.log(`✅ Table ${targetTableId} restored (cameriere class removed via socket)`);
            }
        })
    },
    beforeMount() {
        this.getSettings();
        this.displayProduct();
        this.getTavoli();
        this.displayPrenotazioni();
        this.displayOrdini();
        this.fetchNotifications();
        this.notifInterval = setInterval(this.fetchNotifications, 30000);
    },
    beforeUnmount() {
        if (this.notifInterval) clearInterval(this.notifInterval);
    },

}
</script>

<style scoped>
.prenotati-modal-box {
    background-color: #f1f3f5;
    color: black;
}
.con-sa {
    min-height: 100vh;
    padding-bottom: 50px;
}

.container-calendar-main {
    width: 100%;
    max-width: 100%;
    margin: 0;
    padding: 20px;
}

.cont-info {
    display: flex;
    flex-wrap: nowrap;
    gap: 25px;
    justify-content: center;
    align-items: stretch;
}

.pren {
    flex: 1;
    min-width: 320px;
    background: white;
    padding: 25px;
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.08); /* Slightly stronger shadow for better visibility */
}

.side-column {
    max-width: 450px;
}

.middle-column {
    flex: 3;
    max-width: none;
}

.notifications-column {
    max-height: 85vh;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #888 #f1f1f1;
}

.notifications-column::-webkit-scrollbar {
    width: 6px;
}

.notifications-column::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}

.notifications-column::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
}

.notifications-column::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.preno {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
}

.input-group {
    width: 100% !important;
}

.cont-cal {
    justify-content: center;
    overflow-x: auto;
}

.nav-sale {
    background-color: white;
    padding: 15px;
    margin-bottom: 20px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

.con-sal {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
    align-items: center;
}

.visualizza-sala {
    background-color: white;
    padding: 30px 15px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 20px;
    justify-items: center;
}

.tavolo {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    transition: transform 0.2s;
}

.tavolo:active {
    transform: scale(0.95);
}

.tavolo img {
    width: 60px;
    height: auto;
}

.num-t {
    margin-top: 5px;
    color: #e91e63;
    font-size: 1.1rem;
}

.pano-pren {
    width: 100%;
    margin-top: 15px;
}

.card {
    max-height: 400px;
    overflow-y: auto;
    border: none;
    box-shadow: 0 4px 10px rgba(0,0,0,0.08);
    border-radius: 8px;
}

.nav-tabs {
    flex-wrap: wrap;
}

.prenotato {
   filter: invert(9%) sepia(100%) saturate(7197%) hue-rotate(241deg) brightness(103%) contrast(125%);
}

.ordinato {
    filter: invert(74%) sepia(53%) saturate(5417%) hue-rotate(73deg) brightness(112%) contrast(130%);
}

.cameriere {
   filter: invert(40%) sepia(82%) saturate(6286%) hue-rotate(348deg) brightness(86%) contrast(141%);
}

@media (max-width: 1200px) {
    .cont-info {
        flex-wrap: wrap;
    }
    .middle-column {
        flex: 1 1 100%;
        order: -1;
    }
}

@media (max-width: 768px) {
    .cont-info {
        flex-direction: column;
    }
    .side-column {
        max-width: none;
    }
    
    .visualizza-sala {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 480px) {
    .visualizza-sala {
        grid-template-columns: repeat(2, 1fr);
    }
}

.coperti-modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.coperti-modal-box {
  background: #fff;
  border-radius: 12px;
  padding: 30px;
  min-width: 320px;
  max-width: 400px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.25);
}

.coperti-modal-box h5 {
  margin-bottom: 10px;
  font-weight: 700;
  color: #2c3e50;
}

.coperti-modal-box p {
  color: #555;
  margin-bottom: 15px;
}
</style>